import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Gabriela M.',
  city: 'Guadalajara, MX',
  image: 'https://cdn.magicpatterns.com/uploads/1mqQ9rDNvR2VG9ZtEVN4Uj/7.png',
  quote: 'Antes llegaba a las 6pm con ganas de llorar. Ahora abro el refri y ya sé qué toca. Mis hijos cenaron salmón con brócoli el martes y ni me costó pensarlo.',
  weeks: '3 semanas'
}, {
  name: 'Andrea L.',
  city: 'Medellín, CO',
  image: 'https://cdn.magicpatterns.com/uploads/dscQgUy4Ve7Cj84SoeL2Kf/8.png',
  quote: 'Mi esposo me preguntó «¿contrataste a alguien?» cuando vio la variedad de la semana. No. Solo dejé de improvisar.',
  weeks: '5 semanas'
}, {
  name: 'Valentina R.',
  city: 'Santiago, CL',
  image: 'https://cdn.magicpatterns.com/uploads/m1SkiT9mAhB4UQN4hXfNhd/9.png',
  quote: 'Lo que más me dolía era la culpa. Pedir comida y sentir que fallé otra vez. Ahora cocino cosas simples pero ricas, y la culpa desapareció.',
  weeks: '2 semanas'
}, {
  name: 'Mariana C.',
  city: 'Lima, PE',
  image: 'https://cdn.magicpatterns.com/uploads/ht5S1KmR2v8FEKkQGRauEg/10.png',
  quote: 'Hice tostones con carne mechada un miércoles. ¡Un miércoles! Con la Lista Maestra ya tenía todo comprado desde el domingo.',
  weeks: '4 semanas'
}, {
  name: 'Carolina S.',
  city: 'Madrid, ES',
  image: 'https://cdn.magicpatterns.com/uploads/jaWwBTior8z3jeY6NU3agn/12.png',
  quote: 'Trabajo 10 horas. Llego muerta. Pero ahora la cena ya está decidida. Solo caliento o armo en 20 min.',
  weeks: '6 semanas'
}, {
  name: 'Daniela P.',
  city: 'CDMX, MX',
  image: 'https://cdn.magicpatterns.com/uploads/85Fe3gpDxw8PsgRWBVEjAX/13.png',
  quote: 'Enchiladas verdes un jueves a las 7pm. Antes eso era imposible. Ahora es martes normal con el sistema.',
  weeks: '3 semanas'
}];
export default function TestimonialsSection() {
  return <div className="py-10 px-4 sm:px-6 lg:px-8 bg-brand-cream" data-id="element-374">
      <div className="max-w-4xl mx-auto" data-id="element-375">
        <h3 className="font-heading text-2xl md:text-3xl text-slate-900 text-center mb-1 tracking-wide uppercase" data-id="element-376">
          Resultados reales
        </h3>
        <p className="text-sm text-slate-400 text-center mb-6" data-id="element-377">
          Mamás que cambiaron su semana con CERO DECISIONES
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-id="element-378">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07,
          duration: 0.35
        }} className="bg-white rounded-lg overflow-hidden border border-brand-brown/10" data-id="element-379">
              <img src={t.image} alt={`Comida de ${t.name}`} className="w-full h-28 object-cover" data-id="element-380" />
              <div className="p-2.5" data-id="element-381">
                <div className="flex items-center gap-0.5 mb-1" data-id="element-382">
                  {[...Array(5)].map((_, i) => <Star key={i} size={10} className="fill-brand-brown text-brand-brown" data-id="element-383" />)}
                </div>
                <p className="text-slate-600 text-[11px] leading-snug mb-2 line-clamp-3" data-id="element-384">
                  "{t.quote}"
                </p>
                <div data-id="element-385">
                  <p className="font-semibold text-slate-800 text-[11px]" data-id="element-386">
                    {t.name}
                  </p>
                  <p className="text-slate-400 text-[10px]" data-id="element-387">
                    {t.city} · {t.weeks}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}